var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex flex-col rounded-b-sm pb-10",
      class: _vm.containerClass,
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex justify-between items-center pb-2 mb-2 rounded-t-sm text-black font-semibold filters-container",
        },
        [
          _vm.title
            ? _c("h3", { staticClass: "text-lg" }, [_vm._v(_vm._s(_vm.title))])
            : _vm._e(),
          _vm._t("button", function () {
            return [
              _c("UiButton", {
                attrs: {
                  variant: "secondary",
                  squared: "",
                  buttonText: "Reset",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("click")
                  },
                },
              }),
            ]
          }),
        ],
        2
      ),
      _c("div", [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }